import { render, staticRenderFns } from "./UpdateRoleModal.vue?vue&type=template&id=c935f08e&"
import script from "./UpdateRoleModal.vue?vue&type=script&lang=js&"
export * from "./UpdateRoleModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports